import { createElement } from "react";
import { Trans } from "react-i18next";
import { deleteHttp } from "../../../common/api/apiShared";
import { Result } from "../../../common/api/result";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { IDeleteNationalLawDialog } from "./DeleteNationalLawDialog";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function DeleteNationalLawDialogDataMapping(props: IDeleteNationalLawDialog) {
    const snackbar = useDotLegalSnackbar();

    const removeMutation = useDotLegalMutation(remove);
    const removeNationalLaw = () => {
        removeMutation.mutateAsync(undefined, {
            onSuccess: (response: Result<string>) => {
                props.onCloseDialog();

                if (response.success()) {
                    props.onSaveCorrect();
                    snackbar.show(createElement(Trans, { i18nKey: "nationalLawDeleted", values: { name: props.selectedNationalLaw?.name } }));
                } else {
                    snackbar.show(createElement(Trans, { i18nKey: "nationalLawNotDeleted", values: { name: props.selectedNationalLaw?.name } }), "warning");
                }
            },
        });
    };

    async function remove() {
        return await deleteHttp<string>(`/nationalLaws/${props.selectedNationalLaw.id}`);
    }

    return {
        removeNationalLaw,
        inProgess: removeMutation.isLoading,
    };
}
